import React from 'react'
import propTypes from 'prop-types'

import './AppMenu.css'

const AppMenu = ({ changePage }) => (
  <nav className='app-menu-wrapper'>
    <ul className='app-menu'>
      <li className='selected'>
        <button onClick={() => changePage('/')}>Home</button>
      </li>
      <li>
        <button onClick={() => changePage('/projects')}>Projects</button>
      </li>
    </ul>
  </nav>
)

AppMenu.propTypes = {
  changePage: propTypes.func
}

export default AppMenu


// WEBPACK FOOTER //
// ./src/components/AppMenu/AppMenu.js